import React, { useRef, useState } from "react";
import { RenderNestedHeader } from "./RenderNestedHeader";
import { Attribute, Column, Edge, TableHeaderProps } from "../constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import DataStudioDropdown from "./DataStudioDropdown";
import DeleteSvgIcon from "ReactSvgIcons/DeleteIcon";
import FilterIconDataStudio from "ReactSvgIcons/filterIcon";
import useOutsideClick from "hooks/useOutsideClick";
import DataStudioFilterDropdown from "./DataStudioFilterDropdown";

const TableHeaderCell: React.FC<TableHeaderProps> = ({
  column,
  activeDropdownId,
  dropdownPosition,
  selectedTableColumns,
  setDropdownPosition,
  setActiveDropdownId,
  setSelectedColumns,
  selectedColumns,
  setRowList,
}) => {
  const activeFilterDropdownRef = useRef(null);
  const [activeFilterDropdownId, setActiveFilterDropDownId] =
    useState<string>("");
  const [filteredDropdownPosition, setFilterDropdownPosition] = useState({
    top: 0,
    left: 0,
  });
  const handleDropdown = (
    event: React.MouseEvent<HTMLDivElement>,
    column: Column
  ) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setDropdownPosition({
      top: rect.bottom,
      left: rect.left,
    });
    setActiveDropdownId(
      activeDropdownId === column?.id ? "" : column?.id ?? ""
    );
  };
  const replaceSelectedColumn = (
    column: Column,
    selectedItem: Attribute | Edge
  ) => {
    setSelectedColumns((prev: Column[]) => {
      return prev.map((item) => {
        if (item.id === column?.id) {
          return { ...selectedItem, id: column.id };
        }
        return item;
      });
    });
  };

  const handleFilterDropdown = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    e.stopPropagation();
    setActiveDropdownId("");
    const rect = e.currentTarget.getBoundingClientRect();
    setFilterDropdownPosition({
      top: rect.bottom,
      left: rect.left,
    });
    setActiveFilterDropDownId(
      activeFilterDropdownId === column?.id ? "" : column?.id ?? ""
    );
  };

  const handleDelete = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
    let index = selectedColumns?.findIndex((item) => item.id === column.id);
    if (index !== undefined && index >= 0) {
      setRowList((prev: any) =>
        prev?.map((row: any) => row.filter((_: any, i: number) => i !== index))
      );
    }
    setSelectedColumns((prev) => prev.filter((item) => item.id !== column.id));
  };

  useOutsideClick(() => {
    setActiveFilterDropDownId("");
  }, activeFilterDropdownRef);
  return (
    <div
      style={{
        cursor: column.type === "edge" ? "pointer" : "",
      }}
      className="d-flex flex-column"
    >
      <div
        className="d-flex align-items-center justify-content-between p-2"
        style={{ gap: "3px" }}
        onClick={(event) => handleDropdown(event, column)}
      >
        <div className="d-flex align-items-center gap-1">
          {(column as Attribute)?.displayName || column.name}
          <FontAwesomeIcon className="ms-1" icon={faCaretDown} />
        </div>
        <div
          style={{
            gap: 0.5,
          }}
          className="d-flex align-items-center"
        >
          <div
            onClick={(e) => handleDelete(e)}
            className="data-studio-delete-hover"
          >
            <DeleteSvgIcon height={16} width={16} />
          </div>
          {column.type === "edge" && (
            <div
              ref={
                column.id === activeFilterDropdownId
                  ? activeFilterDropdownRef
                  : undefined
              }
              onClick={(e) => handleFilterDropdown(e)}
              className="data-studio-delete-hover"
            >
              <div className="position-relative">
                <FilterIconDataStudio height={16} width={16} />
                {column?.filters?.length && (
                  <div className="position-absolute data-studio-filter-info">
                    {column?.filters?.length > 99
                      ? "99+"
                      : column?.filters?.length}
                  </div>
                )}
              </div>

              {activeFilterDropdownId === column.id && (
                <DataStudioFilterDropdown
                  position="fixed"
                  dropdownPositionTop={`${filteredDropdownPosition?.top + 1}px`}
                  dropdownPositionLeft={`${
                    filteredDropdownPosition?.left - 150
                  }px`}
                  column={column}
                  selectedTableColumns={selectedTableColumns}
                  setSelectedColumns={setSelectedColumns}
                  setActiveFilterDropDownId={setActiveFilterDropDownId}
                />
              )}
            </div>
          )}
        </div>
        {selectedTableColumns && activeDropdownId === column?.id && (
          <DataStudioDropdown
            options={selectedTableColumns}
            onSelect={(item) => replaceSelectedColumn(column, item)}
            position="fixed"
            dropdownPositionTop={`${dropdownPosition.top}px`}
            dropdownPositionLeft={`${dropdownPosition.left}px`}
          />
        )}
      </div>
      {column.type === "edge" && (
        <RenderNestedHeader
          selectedTableColumns={selectedTableColumns}
          parentColumn={column}
          parentId={column?.id}
          setSelectedColumns={setSelectedColumns}
          activeFilterDropdownId={activeFilterDropdownId}
          setActiveFilterDropDownId={setActiveFilterDropDownId}
        />
      )}
    </div>
  );
};

export default TableHeaderCell;
